import React, { useState } from 'react';
import { BsKey, BsClipboard, BsCheck2, BsChevronDown, BsChevronUp } from 'react-icons/bs';
import { useCustomer } from './CustomerContext';
import StatusBadge from './components/StatusBadge';
import EmptyState from './components/EmptyState';
import SkeletonLoader from './components/SkeletonLoader';
import { formatDate, daysUntil } from '../../utils/api';

const LicenseCard = ({ license }) => {
  const [expanded, setExpanded] = useState(false);
  const [copied, setCopied] = useState(false);
  const days = daysUntil(license.expires_at);
  const pct = license.activation_limit > 0 ? (license.activations_used / license.activation_limit) * 100 : 0;

  const copyKey = () => {
    if (!navigator.clipboard?.writeText) return;
    navigator.clipboard.writeText(license.license_key).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }).catch(() => {});
  };

  return (
    <div className="cp-license-card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <div style={{ fontWeight: 600, fontSize: 15 }}>{license.product_name}</div>
          <div style={{ fontSize: 13, color: '#888' }}>{license.plan_name}</div>
        </div>
        <StatusBadge status={license.status} />
      </div>

      <div className="cp-license-key">
        <span>{license.license_key}</span>
        <button onClick={copyKey} title="Copiar clave">
          {copied ? <BsCheck2 /> : <BsClipboard />}
        </button>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#666', marginBottom: 4 }}>
        <span>Expira: {formatDate(license.expires_at)}</span>
        {days !== null && days <= 30 && days > 0 && (
          <span style={{ color: days <= 7 ? '#c62828' : '#f57f17', fontWeight: 600 }}>{days} dias restantes</span>
        )}
        {days !== null && days <= 0 && <span style={{ color: '#c62828', fontWeight: 600 }}>Expirada</span>}
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#666', marginBottom: 4 }}>
        <span>Activaciones</span>
        <span style={{ fontWeight: 600 }}>{license.activations_used}/{license.activation_limit}</span>
      </div>
      <div className="cp-progress-bar">
        <div className="cp-progress-fill" style={{ width: `${Math.min(100, pct)}%` }} />
      </div>

      {license.activations && license.activations.length > 0 && (
        <div style={{ marginTop: 12 }}>
          <button
            onClick={() => setExpanded(!expanded)}
            style={{ background: 'none', border: 'none', color: 'var(--cp-accent)', fontSize: 13, fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4, padding: 0 }}
          >
            {expanded ? <BsChevronUp /> : <BsChevronDown />} Sitios activados ({license.activations.length})
          </button>
          {expanded && (
            <div style={{ marginTop: 8 }}>
              {license.activations.map((a, i) => (
                <div key={i} style={{ fontSize: 13, padding: '4px 0', borderBottom: '1px solid #f5f5f5', display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: '#333' }}>{a.site_url}</span>
                  <StatusBadge status={a.status} />
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const CustomerLicensesPage = () => {
  const { licenses, loading } = useCustomer();

  if (loading) {
    return (
      <div>
        <div className="cp-skeleton cp-skeleton-title" />
        <div className="cp-license-grid">
          <SkeletonLoader type="card" count={3} />
        </div>
      </div>
    );
  }

  return (
    <div>
      <h1 className="cp-page-title">Licencias</h1>
      {!licenses.length ? (
        <EmptyState icon={BsKey} title="Sin licencias" subtitle="Aún no tienes licencias de software activas." />
      ) : (
        <div className="cp-license-grid">
          {licenses.map(l => <LicenseCard key={l.id} license={l} />)}
        </div>
      )}
    </div>
  );
};

export default CustomerLicensesPage;
